import { render, staticRenderFns } from "./SearchContent.vue?vue&type=template&id=b1ce01e0&scoped=true&"
import script from "./SearchContent.vue?vue&type=script&lang=js&"
export * from "./SearchContent.vue?vue&type=script&lang=js&"
import style0 from "./SearchContent.vue?vue&type=style&index=0&id=b1ce01e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce01e0",
  null
  
)

component.options.__file = "SearchContent.vue"
export default component.exports